// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__pG_d_","primaryButton":"button_primaryButton__ZuO4u"};